import * as yup from 'yup'

class Branch {
  _id = ''
  name = ''
  timezone = ''
  outboundEmail = ''
  outboundName = ''
  outboundRefreshToken = ''
  phone = ''
  defaultHourlyRate = 0
  googlePlusUrl = ''
  facebookUrl = ''
  yelpUrl = ''
  twitterUrl = ''
  gatherupUrl = ''
  instagramUrl = ''
  samsaraId = ''
  active = true
  latitude = 0
  longitude = 0
  market = ''
  awardStreak = ''
  normalizedAddress?: string = ''
  regionId = 0
}

const BranchValidationSchema = yup.object().shape({
  _id: yup.string().matches(/^[a-f\d]{24}$/i, { excludeEmptyString: true }),
  name: yup.string().required('This field is required'),
  timezone: yup.string().required('This field is required'),
  outboundEmail: yup.string().email().required('This field is required'),
  outboundName: yup.string().required('This field is required'),
  phone: yup.string().required('This field is required'),
  defaultHourlyRate: yup.number().min(1, 'Cannot be zero').required('This field is required'),
  googlePlusUrl: yup.string().url('Invalid url'),
  facebookUrl: yup.string().url('Invalid url'),
  yelpUrl: yup.string().url('Invalid url'),
  twitterUrl: yup.string().url('Invalid url'),
  gatherupUrl: yup.string().url('Invalid url'),
  samsaraId: yup.string().url('Invalid url'),
  instagramUrl: yup.string().url('Invalid url'),
  market: yup.string(),
  awardStreak: yup.string(),
  active: yup.boolean(),
  outboundRefreshToken: yup.string().when('active', {
    is: true,
    then: (schema: any) => schema.required('Token is required when branch is active'),
  }),
  normalizedAddress: yup.string().required('Address field is required'),
  regionId: yup.number().required('Region field is required'),
})

export type BranchSet = Branch[]

export { Branch, BranchValidationSchema }
